<template>
  <div class="collapse-item" @click="toggle">
    <div class="collapse-item-header" :class="{ open: isOpen }">
      <span class="icon-wrapper"><i class="icon bis-menu_down"></i> </span>
      <slot name="header"></slot>
    </div>
    <transition-expand>
      <div v-if="isOpen" class="collapse-item-body">
        <div class="collapse-item-body-wrapper">
          <slot></slot>
        </div>
      </div>
    </transition-expand>
  </div>
</template>

<script>
import TransitionExpand from "./TransitionExpand";

export default {
  name: "AppCollapseItem",
  components: {
    TransitionExpand
  },
  props: {},
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      if (this.$parent.accordion) {
        this.$parent.$emit("close-all", this._uid);
      }
    }
  }
};
</script>

<style scoped lang="scss" type="text/scss">
.collapse-item {
  width: 100%;
  cursor: pointer;
  border-bottom: 1px solid #1f1a18;
  .collapse-item-header {
    font-weight: 600;
    font-size: 18px;
    position: relative;
    padding-top: 10px;
    padding-bottom: 10px;
    .icon-wrapper {
      position: absolute;
      right: 0;
      transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }
    &.open {
      .icon-wrapper {
        transform: rotateZ(180deg);
      }
    }
  }

  .collapse-item-body-wrapper {
    padding-top: 5px;
    padding-bottom: 10px;
  }
}

.expand-enter-active,
.expand-leave-active {
  transition-property: opacity, height;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
}
</style>
